import { create } from "@bufbuild/protobuf";
import { PaginationArgumentsSchema, type Order, type PaginationArguments, type PaginationPageInfo } from "#gen/common/v1/pagination_pb.js";
import type { User } from "#gen/identities/v1/identities_pb.js";
import { DEFAULT_PAGE_SIZE } from "#lib/api/api.js";
import { AssetState } from "#lib/api/bundles.js";

export interface Filter {
	namePrefix?: string;
	tags?: string[];
	states?: string[];
	creators?: User[];
	visibilities?: string[];
	categories?: string[];
	folderPath?: string;
	exactName?: string;
	includeDescendants?: boolean;
}

export function isFilterEmpty(filter: Filter): boolean {
	return !filter.namePrefix && filter.categories?.length === 0 && filter.tags?.length === 0 && filter.creators?.length === 0;
}

export function isActive(filter: Filter): boolean {
	if (!filter.states || filter.states.length === 0) {
		return true;
	}
	return filter.states[0] === AssetState.ACTIVE;
}

export function isDraft(filter: Filter): boolean {
	if (!filter.states || filter.states.length === 0) {
		return false;
	}
	return filter.states[0] === AssetState.DRAFT;
}

export function isArchived(filter: Filter): boolean {
	if (!filter.states || filter.states.length === 0) {
		return false;
	}
	return filter.states[0] === AssetState.ARCHIVED;
}

export function calculateFilterCount(filter: Filter): number {
	let count = 0;
	if (filter.categories && filter.categories.length > 0) {
		count += filter.categories.length;
	}
	if (filter.tags && filter.tags.length > 0) {
		count += filter.tags.length;
	}
	if (filter.creators && filter.creators.length > 0) {
		count += filter.creators.length;
	}
	return count;
}

export function clearFilter(filter: Filter): Filter {
	filter.categories = [];
	filter.tags = [];
	filter.creators = [];
	return filter;
}

export function createNextPageArguments(pageInfo: PaginationPageInfo | undefined, sortKey?: string, sortDirection?: Order, limit?: number): PaginationArguments | undefined {
	if (pageInfo?.hasNextPage) {
		return create(PaginationArgumentsSchema, {
			first: limit ?? DEFAULT_PAGE_SIZE,
			after: pageInfo.endCursor,
			orderBy: sortKey,
			order: sortDirection,
		});
	}
	return;
}

export function createPreviousPageArguments(pageInfo: PaginationPageInfo | undefined, sortKey?: string, sortDirection?: Order, limit?: number): PaginationArguments | undefined {
	if (pageInfo?.hasPreviousPage) {
		return create(PaginationArgumentsSchema, {
			last: limit ?? DEFAULT_PAGE_SIZE,
			before: pageInfo.startCursor,
			orderBy: sortKey,
			order: sortDirection,
		});
	}
	return;
}

export function clearPagination(pagination: PaginationArguments | undefined) {
	if (pagination) {
		pagination.after = undefined;
		pagination.before = undefined;
	}
}
